import { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';
import { applyThemeColors, clearThemeColorOverrides } from '../utils/themeDefaults';

const isThemePreviewIframe = () =>
  window.parent !== window
  && new URLSearchParams(window.location.search).get('themePreview') === '1';

export const usePublicTheme = () => {
  const { settings } = useSettings();

  useEffect(() => {
    if (isThemePreviewIframe()) {
      return;
    }

    applyThemeColors(settings.themeColors);
  }, [settings.themeColors]);
};

export const useAdminThemeIsolation = () => {
  useEffect(() => {
    clearThemeColorOverrides();
  }, []);
};
